/*
 * @Author: zhaoshuaiqiang
 * @Date: 2020-09-10 11:14:47
 * @LastEditTime: 2020-09-16 10:38:17
 * @LastEditors: zhaoshuaiqiang
 * @Description: 封装的埋点类
 * @FilePath: /oversea-web/client/utils/logger.ts
 */
/* eslint-disable @typescript-eslint/camelcase */
import { Weblog, BaseOptions, LoggerConfigByUser } from '@ks/weblogger';
import cookie from '@/client/utils/cookie';
import { parseQuery } from '@/client/utils/url';

// 这个环境变量是webpack打包时注入的，不是在环境中进行配置
const { API_ENV } = process.env;
const isProd = API_ENV === 'production';

export default class OverseaLog {
  private logger: Weblog;
  private overseaBaseConfig: BaseOptions = {
    version_name: cookie.getItem('appver') || '',
    network_type: (cookie.getItem('net') || 'unknown') as NetworkType,
    channel: cookie.getItem('c') || '',
    product_name: 'KWAI_BULLDOG',
    package_name: '',
    user_id: cookie.getItem('ud') || '',
  };
  // 测试环境和线上环境的点都是直接打线上
  private overseaLogConfig: LoggerConfigByUser = {
    env: isProd
      ? 'https://g-logsdk.snackvideo.com/rest/wd/common/log/collect/misc2'
      : `${window.location.origin}/rest/wd/common/log/collect/misc2`,
    autoPV: false,
    fps: false,
  };

  constructor(logConfig = {}, baseConfig = {}) {
    const totalLogConfig = { ...this.overseaLogConfig, ...logConfig };
    const totalBaseConfig = { ...this.overseaBaseConfig, ...baseConfig };
    this.logger = new Weblog(totalLogConfig, totalBaseConfig);
    const { plugins } = this.logger;
    const { logger, sendPv, sendShow, sendClick, sendClickV2, updateCurrentUrlPackage } = this;
    // tLogger 为logger上层的业务封装
    const tLogger = { logger, plugins, sendPv, sendShow, sendClick, sendClickV2, updateCurrentUrlPackage };
    return tLogger as any;
  }
  public sendPv(page: string, params: object, type = 'ENTER', beginTime?: number) {
    // 如果params默认为空的话，weblogger会带上所有query；这里我们手动处理，无论是否为空都带上所有query参数
    const query = parseQuery();
    if (params) {
      params = Object.assign(query, params);
    } else {
      params = query;
    }
    const info = { page, type, params };
    // this.logger.updateCurrentUrlPackage(location.href); // 埋点防止pv打两次
    this.logger.sendImmediately('PV', { ...info, beginTime });
  }
  public sendShow(showName: string, params = {}) {
    this.logger.sendImmediately('SHOW', showName, params);
  }
  public sendClick(elementName: string, params = {}) {
    this.logger.sendImmediately('CLICK', elementName, params);
  }

  public sendClickV2(params: any) {
    this.logger.sendImmediately('CLICK', params);
  }
  public updateCurrentUrlPackage(href: string) {
    this.logger.updateCurrentUrlPackage(href);
  }
}

type NetworkType = 'unknown' | 'none' | 'wifi' | '4g' | '3g' | '2g';
